import { Col, Flex, notification, Row, Space } from "antd";
import React from "react";
import LocationsApi from "../../api-services/locations-api.service";
import { Country } from "../../interfaces/country.interface";


export default class Footer extends React.Component {
  api = new LocationsApi;

  state = {
    countries: []
  }

  menus = [
    {
      label: "Home",
      link: "/web"
    },
    {
      label: "pdpa",
      link: "",
      target: "_blank"
    },
    {
      label: "about us",
      link: "/web/about-us"
    },
    {
      label: "privacy policy",
      link: "",
      target: "_blank"
    },
    {
      label: "contact us",
      link: "/web/contact-us"
    },
    {
      label: "terms & conditions",
      link: "",
      target: "_blank"
    },
  ]

  componentDidMount() {
    this.api.getCountries()
      .then(({locations}) => {
        this.setState({countries: locations})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading countries.'});
      });
  }
  
  render(){
    return (
      <div className="footer">
        <div className="footer_body">
          <Row className="footer_links" gutter={[12, 12]}>
            {
              this.state.countries.length > 0 &&
                <Col className="column medium-column">
                  <Space direction="vertical">
                    <div className="link-group-title">Countries</div>
                    <div className="link-group-items">
                      {
                        this.state.countries.map((country: Country)=> <a key={country.id} href={`/web/listing?keyword=${country.name}&location_id=${country.id}`} target="_self"> {country.name} </a> )
                      }
                    </div>
                  </Space>
                </Col>
            }
            <Col className="column footer-menu large-column">
              <Space direction="vertical">
                <div className="link-group-items">
                  {
                    this.menus.map((menu, index) =><a key={index} target={menu.target} href={menu.link}> {menu.label} </a>)
                  }
                </div>
              </Space>
            </Col>
            <Col className="column contact-info small-column">
              <Space direction="vertical" align="center">
                <Flex vertical gap="20px" align="center">
                  <div className="link-group-title">Contact Us</div>
                  <div><a href="/web/contact-agents">contact agents</a></div>
                  <div className="link-group-title">Follow us on</div>
                  <Flex gap={20} justify="space-between" className="social-icons">
                    <a target="_blank" href="https://www.facebook.com/thesignaturetour"><img src="/iceholidays-assets/images/social/ico_fb.png"/></a>
                    <a target="_blank" href="https://wa.me/60128688148"><img src="/iceholidays-assets/images/social/ico_whatsapp.png"/></a>
                    <a target="_blank" href="https://www.instagram.com/thesignaturetours"><img src="/iceholidays-assets/images/social/ico_ig.png"/></a>
                  </Flex>
                </Flex>
              </Space>
            </Col>
          </Row>
          <div id="copyright">
            <span>Copyright © {(new Date().getFullYear())} The Signatures Tours</span>
          </div>
        </div>
      </div>
    ) 
  }
}